import type { TypedUseQuerySubscriptionOptions } from '@reduxjs/toolkit/query/react';
import useDevicesManager from './useDevicesManager';
import { useMemo } from 'react';

type Options = TypedUseQuerySubscriptionOptions;

function useDeviceManager(
  args: { storeId: string; deviceId?: string },
  options: Options = {}
) {
  const { storeId, deviceId } = args;
  const responseDevicesAPI = useDevicesManager(storeId, options);
  const { data: devices } = responseDevicesAPI;
  const data = useMemo(
    () => devices?.find((device) => device.uuid === deviceId),
    [deviceId, devices]
  );

  return {
    ...responseDevicesAPI,
    data,
  };
}

export default useDeviceManager;
